// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__yZpFc","popup":"styles_popup__Xf0fQ","closeButton":"styles_closeButton__xXUeA"};